import classNames from 'classnames'

import type { FacetValue } from '../../types'

type Props = {
  facetValue: FacetValue
  onFacetChange(value: { key: string; value: string }): void
  showQuantity?: boolean
}

export function Default({ facetValue, onFacetChange, showQuantity }: Props) {
  return (
    <button
      onClick={() => {
        onFacetChange({ key: facetValue?.key, value: facetValue?.value })
      }}
      data-store-label
      data-testid="store-label"
      className={classNames(
        'flex gap-1 justify-between sm:justify-start px-4 py-3 text-sm font-medium items-center border rounded-round',
        facetValue.selected
          ? 'border-restructure-background-blue text-primaryBlue'
          : 'border-restructure-background-neutral-5 text-[#000]'
      )}
    >
      {facetValue.label}
      {showQuantity && (
        <span className="mt-[2px] text-tertiary text-xs font-normal">
          {facetValue.quantity}
        </span>
      )}
    </button>
  )
}
